<template>
<div>
  <div class="footer">
    <div class="container">
      <div class="footer-top">
        <!-- <div class="footer-followus">
          <span>Follow Us On：</span>
          <a class="ico-1" href="##"></a>
          <a class="ico-2" href="##"></a>
          <a class="ico-3" href="##"></a>
        </div> -->
        <ul class="footer-nav">
            <li><a href="https://zfx.co.uk/about-zfx/">About</a></li>
            <li style="width: auto;"><a href="https://zfx.co.uk/products/">Trading Instruments</a></li>
            <li><a href=" https://zfx.co.uk/platforms/">Platform & Tools</a></li>
            <li style="width: auto;"><a href="https://zfx.co.uk/terms-agreements/">Terms &amp; Agreements</a></li>
        </ul>
      </div>
      <p><b>RISK WARNING: Contracts for Difference (CFDs) are margined products, you could lose more money than you deposit.</b></p>
      <p>This website: my.zfx.co.uk is operated by Zeal Capital Market (UK) Limited, a wholly owned subsidiary of Zeal Holdings Limited, the holding company of Zeal group of companies (collectively Zeal Group).</p>
      <p>All products and services promoted on this website are only intended for and directed at Professional Clients as defined under the Markets in Financial Investment Directive (MiFID) implemented by the Financial Conduct Authority.</p>
      <p>ZFX, Zeal, and the multi-coloured “Z” are trading names, service marks or trademarks of Zeal Holdings Limited and may be used exclusively by its affiliated group entities with permission.</p>
      <p><b>Regulated Zeal Group Entities</b><br>Zeal Capital Market (UK) Limited is a wholly owned subsidiary of Zeal Holdings Limited, authorised and regulated by the Financial Conduct Authority, FRN: 768451. It is a company registered in England and Wales with register number: 10219924 and registered office at 4 Lombard Street, London, EC3V 9HD, United Kingdom.</p>
      <p>Zeal Capital Market (Seychelles) Limited is a wholly owned subsidiary of Zeal Holdings Limited, regulated as a Securities Dealer by the Financial Services Authority of Seychelles, licence number: SD027. Its principal office is at: Suite C, Orion Mall, Palm Street, Victoria, Mahe, Seychelles.</p>
      <p>Zeal Capital Market (UK) Limited cannot accept any live trading account applications from clients who are residents of Canada: British Columbia, Ontario, and Quebec, USA (other than Eligible Contract Participants) and Japan.</p>
      <div class="coopright">© {{new Date().getFullYear()}} Zeal Capital Market (UK) Limited
        <div class="footer-link fr">
                <a target="_blank" href="https://www.zfx.co.uk/wp-content/uploads/sites/2/2021/01/Privacy_Policy.pdf">Privacy Policy</a>
                <a target="_blank" href="https://www.zfx.co.uk/wp-content/uploads/2021/Risk_Disclosure.pdf">Risk Disclosure</a>
                <a target="_blank" href="https://www.zfx.co.uk/wp-content/uploads/2021/Cookie_Policy.pdf">Cookie Policy</a>
            </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';

.footer {
  padding-bottom: 34px;
  padding-top: 50px;
  font-family: 'AdobeHeitiStd-Regular';
  font-size: 12px;
  line-height: 25px;
  color: #999999;
  background-color: #2e2d2d;
  .risk {
    text-align: center;
    font-weight: bold;
  }
  .footer-top {
    overflow: hidden;
    margin-bottom: 34px;
  }
  .footer-nav {
    li {
      position: relative;
      float: left;
      width: 100px;
      border-bottom: 1px solid #404040;
      padding-bottom: 19px;
      line-height: 1;
      color: #fff;
      margin-right: 60px;
      font-weight: bold;
      &:before {
        position: absolute;
        left: 0;
        bottom: 0;
        content: '';
        display: block;
        width: 56px;
        width: 56px;
        height: 1px;
        background-color: #0A95FF;
      }
    }
  }
  .footer-followus {
    float: right;
    font-size: 0;
    span {
      font-size: 14px;
      vertical-align: middle;
    }
    a {
      display: inline-block;
      vertical-align: middle;
      width: 34px;
      height: 34px;
      background-color: #999999;
      margin-left: 12px;
    }
    .ico-1 {
      background: url(~assets/img/footer-f.png) no-repeat;
    }
    .ico-2 {
      background: url(~assets/img/footer-b.png) no-repeat;
    }
    .ico-3 {
      background: url(~assets/img/footer-g.png) no-repeat;
    }
  }
  .coopright {
    margin-top: 29px;
  }
  p a {
    color: #0A95FF;
    text-decoration: underline;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
}
.footer .footer-link {
  float: right;
}
.footer .footer-link a:after {
  content: '';
  display: inline-block;
  height: 11px;
  border: 1px solid #646464;
  vertical-align: middle;
  margin-left: 5px;
  margin-right: 5px;
}
.footer .footer-link a:last-child:after {
  display: none;
}
p {
  margin-bottom: 1.4em;
  line-height: 1.6;
}
</style>
